const drawerCartSelector = '#cart-drawer .drawer-content';
const cartSelector = '#cart';

function getSelector(element) { 
  return element.id
    ? `#${element.id}`
    : `${element.tagName.toLowerCase()}${element.classList.length ? `.${[...element.classList].join('.')}` : ''}`;
}

function saveCartState() {
  const element = document.querySelector(drawerCartSelector)
    ? document.querySelector(drawerCartSelector)
    : document.querySelector(cartSelector);

  if (!element) {
    return;
  }

  const state = {};
  state.details = [];
  element.querySelectorAll('details[open]').forEach((details) => {
    state.details.push({
      selector: getSelector(details),
    });
  });
  state.scrollTop = element.scrollTop;
  state.scrollBottom = element.scrollHeight - element.scrollTop - element.clientHeight;
  console.log('save state', state);
  return state;
}

function restoreCartState(state) {
  console.log('restore state', state);
  const element = document.querySelector(drawerCartSelector)
    ? document.querySelector(drawerCartSelector)
    : document.querySelector(cartSelector);

  if (!element) {
    return;
  }

  state.details.forEach((item) => {
    const details = element.querySelector(item.selector);
    if (details) {
      if (details.closest('[data-should-choose="false"]')) {
        details.open = false;
      } else {
        details.open = true;
      }
    }
  });

  const currentScrollTop = element.scrollTop;
  const currentScrollBottom = element.scrollHeight - currentScrollTop - element.clientHeight;
  const newScrollTop = currentScrollTop + currentScrollBottom - state.scrollBottom;
  element.scrollTop = newScrollTop;
}

class GiftsData extends HTMLElement {
  constructor() {
    super();

    let addElements = this.querySelectorAll('gift-add');
    let removeElements = this.querySelectorAll('gift-remove');
    let removeData = false;
    let addData = false;

    //console.log('GiftsData', addElements, removeElements);

    if (removeElements && removeElements.length > 0) {
      let removeObject = {};
      removeElements.forEach((item) => {
        let lineId = item.getAttribute('data-line');
        //removeData.push(lineId);
        removeObject[lineId] = 0;
      });
      removeData = {
        updates: removeObject,
      };
    }
    if (addElements && addElements.length > 0) {
      let addArray = [];
      addElements.forEach((item) => {
        addArray.push({
          id: item.getAttribute('data-id'),
          quantity: item.getAttribute('data-quantity'),
          properties: {
            _type: 'gift',
            _campaign_title: item.getAttribute('data-campaign-title'),
          },
        });
      });
      addData = {
        items: addArray,
      };
    }

    const sectionsToRender = window.renderOnEvent['cart:updated'].join(',');

    //console.log('GiftsData', addData, removeData);

    if (removeData && addData) {
      //window.Helpers.Sections.OnEventForm('cart:updated');
      const state = saveCartState();
      addData['sections'] = sectionsToRender;
      this.removeGifts(removeData)
        .then((response) => {
          return response.json();
        })
        .then((json) => {
          this.addGifts(addData)
            .then((response) => {
              return response.json();
            })
            .then((json) => {
              window.Helpers.Sections.Render(json.sections);
              restoreCartState(state);
              window.Helpers.API.Cart.Update({
                attributes: {
                  atc_added: 'true',
                },
              });
              //window.dispatchEvent(new CustomEvent('cart:updated', { detail: json }));
            });
        });
    } else if (removeData) {
      //window.Helpers.Sections.OnEventForm('cart:updated');
      const state = saveCartState();
      removeData['sections'] = sectionsToRender;
      this.removeGifts(removeData)
        .then((response) => {
          return response.json();
        })
        .then((json) => {
          window.Helpers.Sections.Render(json.sections);
          restoreCartState(state);
          window.Helpers.API.Cart.Update({
            attributes: {
              atc_added: '',
            },
          });
          //window.dispatchEvent(new CustomEvent('cart:updated', { detail: json }));
        });
    } else if (addData) {
      //window.Helpers.Sections.OnEventForm('cart:updated');
      const state = saveCartState();
      addData['sections'] = sectionsToRender;
      this.addGifts(addData)
        .then((response) => {
          return response.json();
        })
        .then((json) => {
          window.Helpers.Sections.Render(json.sections);
          restoreCartState(state);
          window.Helpers.API.Cart.Update({
            attributes: {
              atc_added: 'true',
            },
          });
          //window.dispatchEvent(new CustomEvent('cart:updated', { detail: json }));
        });
    }
  }

  addGifts(formData) {
    return window.Helpers.API.Cart.Add(formData);
  }
  removeGifts(formData) {
    return window.Helpers.API.Cart.Update(formData);
  }
}

if (!customElements.get('gifts-data')) {
  customElements.define('gifts-data', GiftsData);
}

class ChooseGift extends HTMLElement {
  constructor() {
    super();
    this.allButtons = this.querySelectorAll('[data-add-variant], [data-remove-variant]');
    this.sectionsToRender = window.renderOnEvent['cart:updated'].join(',');
    this.attachListeners();
    this.details = this.querySelector('#cart-gift-picker');
    this.shouldChoose = this.getAttribute('data-should-choose') === 'true';
    this.available = this.querySelectorAll('.choose-gift[data-available="true"]').length;
    this.selected = this.querySelectorAll('.choose-gift [data-remove-variant]').length;
    if (this.shouldChoose) {
      //this.details.open = true;
    } else {
      this.details.open = false;
    }
  }
  attachListeners() {
    this.allButtons.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();

        const state = saveCartState();

        if (button.getAttribute('data-add-variant')) {
          let variantId = button.getAttribute('data-add-variant');
          const addData = {
            items: [
              {
                id: variantId,
                quantity: button.getAttribute('data-quantity'),
                properties: {
                  _type: 'gift_picker',
                  _campaign_title: button.getAttribute('data-campaign-title'),
                },
              },
            ],
          };
          addData['sections'] = this.sectionsToRender;

          if (button.getAttribute('data-disabled')) {
            // remove previous gift first
            if (document.querySelector('[data-remove-variant]')) {
              const removeBtn = document.querySelector('[data-remove-variant]');
              let lineId = removeBtn.getAttribute('data-remove-variant');
              const removeData = {
                updates: {
                  [lineId]: 0,
                },
              };
              //console.log('remove previous gift', lineId);
              window.Helpers.API.Cart.Update(removeData).then((response) => {
                window.Helpers.API.Cart.Add(addData)
                  .then((response) => {
                    return response.json();
                  })
                  .then((json) => {
                    window.Helpers.Sections.Render(json.sections);
                    restoreCartState(state);
                    //window.dispatchEvent(new CustomEvent('cart:updated', { detail: json }));
                  });
              });
            } else {
              // do nothing - no gift to remove
            }
          } else {
            window.Helpers.API.Cart.Add(addData)
              .then((response) => {
                return response.json();
              })
              .then((json) => {
                window.Helpers.Sections.Render(json.sections);
                restoreCartState(state);
                //window.dispatchEvent(new CustomEvent('cart:updated', { detail: json }));
              });
          }
        } else if (button.getAttribute('data-remove-variant')) {
          let lineId = button.getAttribute('data-remove-variant');
          const removeData = {
            updates: {
              [lineId]: 0,
            },
          };
          removeData['sections'] = this.sectionsToRender;
          //console.log('removing', removeData);
          window.Helpers.API.Cart.Update(removeData)
            .then((response) => {
              return response.json();
            })
            .then((json) => {
              window.Helpers.Sections.Render(json.sections);
              restoreCartState(state);
              //window.dispatchEvent(new CustomEvent('cart:updated', { detail: json }));
            });
        }
      });
    });
  }
}
if (!customElements.get('choose-gift')) {
  customElements.define('choose-gift', ChooseGift);
}

class CustomCart extends HTMLElement {
  constructor() {
    super();
    this.submitBtn = this.querySelector('button[name="checkout"]');
    this.form = this.querySelector('form');
    this.isDrawer = this.getAttribute('data-drawer') === 'true';
    this.attachListeners();
  }

  onFormSubmit(e) {
    /*
    if (document.querySelector('choose-gift[data-should-choose="true"]')) {
      e.preventDefault();
      if (this.submitBtn.parentNode && this.submitBtn.parentNode.querySelector('.cart-item__error')) {
        this.submitBtn.parentNode.querySelector('.cart-item__error').remove();
      }
      const errorElement = document.createElement('p');
      errorElement.classList.add('cart-item__error', 'pb-12', 'pt-12');
      errorElement.textContent = 'Please choose a gift before checking out';
      this.submitBtn.parentNode.insertBefore(errorElement, this.submitBtn);
      return false;
    }
    */
  }

  connectedCallback() {
    if (this.hasAttribute('data-clear-atc-removed')) {
      window.Helpers.API.Cart.Update({
        attributes: {
          atc_removed: '',
          atc_added: '',
        }
      });
    }
  }

  attachListeners() {
    window.addEventListener('cart:updated', function (e) {
      const preventDrawerShow = e && e.detail && e.detail.preventDrawerShow;
      //console.log('CART WAS UPDATED', e);
      if (document.querySelector('#cart-drawer') && !preventDrawerShow) {
        //console.log('CART DRAWER ELEMENT', document.querySelector('#cart-drawer'));
        document.querySelector('#cart-drawer').showModal();
      }
    });
    if (this.form) {
      this.form.addEventListener('submit', this.onFormSubmit.bind(this));
    }
    if (this.submitBtn) {
      this.submitBtn.addEventListener('click', this.onFormSubmit.bind(this));
    }
  }
}

customElements.define('custom-cart', CustomCart);

class CartItem extends HTMLElement {
  constructor() {
    super();
    this.qtyInput = this.querySelector('.cart-item__quantitiy');
    if (this.qtyInput) {
      this.qtyPlus = this.querySelector('.cart-item__quantitiy--plus');
      this.qtyMinus = this.querySelector('.cart-item__quantitiy--minus');
      this.changeQtyUrl = this.qtyInput.getAttribute('data-change-url');
      this.qtyMin = this.qtyInput.getAttribute('min');
      this.qtyMax = this.qtyInput.getAttribute('max');

      this.attachQtyListeners();
    }
    this.removeBtn = this.querySelector('.cart-item__remove');
    this.changeBtns = this.querySelectorAll(
      'a[href*="/cart"]:not(.cart-item__quantitiy--plus, .cart-item__quantitiy--minus, .cart-item__remove)',
    );
    this.qtyDropdown = this.querySelector('details.quantity_details');

    this.attachOtherListeners();
  }

  removeItemAnimation() {
    this.classList.add('cart-item--removing');
  }

  updateViaUrl(requestUrl) {
    //console.log('updateViaUrl', requestUrl);
    window.Helpers.Sections.OnEventForm('cart:updated');
    let newRequestUrl = requestUrl;
    if (window.renderOnEvent['cart:updated']) {
      if (newRequestUrl.indexOf('?') > -1) {
        newRequestUrl += '&';
      } else {
        newRequestUrl += '?';
      }
      newRequestUrl += 'sections=' + window.renderOnEvent['cart:updated'].join(',');
    }
    if (newRequestUrl.indexOf('?') > -1) {
      newRequestUrl = newRequestUrl.replace('?', '.js?');
    } else {
      newRequestUrl += '.js';
    }
    window.Helpers.API.Request(newRequestUrl, 'GET')
      .then((response) => {
        return response.json();
      })
      .then((json) => {
        if (!json.sections) window.location.href = requestUrl;
        window.Helpers.Sections.Render(json.sections);
        window.dispatchEvent(new CustomEvent('cart:updated', { detail: json }));
      })
      .catch((err) => {
        console.error(err);
        window.Helpers.Sections.OnEventError('cart:updated');
      });
  }

  attachQtyListeners() {
    let inputChangeTimeout;
    const _this = this;

    this.qtyPlus.addEventListener('click', (e) => {
      e.preventDefault();
      const newQty = parseInt(_this.qtyInput.value) + 1;
      if (newQty <= _this.qtyMax) {
        _this.qtyInput.value = newQty;
        _this.qtyInput.dispatchEvent(new Event('input'));
      }
      return false;
    });

    this.qtyMinus.addEventListener('click', (e) => {
      e.preventDefault();
      const newQty = parseInt(_this.qtyInput.value) - 1;
      if (newQty >= _this.qtyMin) {
        _this.qtyInput.value = newQty;
        _this.qtyInput.dispatchEvent(new Event('input'));
      }
      return false;
    });

    this.qtyInput.addEventListener('input', (e) => {
      const value = this.qtyInput.value;
      clearTimeout(inputChangeTimeout);
      inputChangeTimeout = setTimeout(() => {
        let requestUrl = this.changeQtyUrl + value;
        if (value == 0) _this.removeItemAnimation();
        this.updateViaUrl(requestUrl);
      }, 200);
    });
  }

  attachOtherListeners() {
    const _this = this;

    if (_this.qtyDropdown) {
      _this.qtyDropdown.addEventListener('toggle', (e) => {
        if (_this.qtyDropdown.open) {
          _this.qtyDropdown
            .querySelector('.cart-item__quantity--active')
            .scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
        }
      });
    }

    if (this.removeBtn) {
      this.removeBtn.addEventListener('click', (e) => {
        console.log('remove click', _this.removeBtn);
        e.preventDefault();
        const isAtc = _this.removeBtn.classList.contains('cart-item__remove--atc');
        let requestUrl = _this.removeBtn.getAttribute('href');
        if (!isAtc) {
          this.removeItemAnimation();
          this.updateViaUrl(requestUrl);
        } else {
          window.Helpers.API.Cart.Update({
            attributes: {
              atc_removed: true,
            }
          }).then(() => {
            this.removeItemAnimation();
            this.updateViaUrl(requestUrl);
          });
        }
      });
    }

    this.changeBtns.forEach((link) => {
      link.addEventListener('click', (e) => {
        console.log('change click', link);
        const isCommand = link.hasAttribute('commandfor');

        if (!isCommand) {
          e.preventDefault();
          e.target.setAttribute('aria-current', true);
          if (e.target.closest('li')) e.target.closest('li').setAttribute('aria-current', true);
          let requestUrl = link.getAttribute('href');
          _this.updateViaUrl(requestUrl);
        }
      });
    });
  }
}

customElements.define('cart-item', CartItem);

class CartCheckout extends HTMLElement {
  constructor() {
    super();
    this.submit = this.querySelector('button');
    this.submit.addEventListener('click', this.onSubmit.bind(this));
  }

  onSubmit (e) {
    const cart = this.closest('custom-cart');

    if (!cart || !cart.hasAttribute('data-require-gifts-selection')) {
      return;
    }

    const gifts = cart ? cart.querySelector('choose-gift') : null;
    const alert = this.querySelector('.cart-checkout__alert');

    if (gifts
      && gifts.shouldChoose
      && gifts.available !== gifts.selected
      && !window.requiredGiftSelectionOnce
    ) {
      e.preventDefault();
      alert.classList.remove('hidden');
      window.requiredGiftSelectionOnce = true;
    }
  }
}

customElements.define('cart-checkout', CartCheckout);
